import Vue from 'vue'
import App from './App.vue'
import Textra from 'vue-textra'
import Vuelidate from 'vuelidate'

Vue.use(Textra)
Vue.use(Vuelidate)

Vue.config.productionTip = false

// window.rootDomain = 'https://kit-magazine.blyxbrj4-liquidwebsites.com/wp-content/themes/kit-child-theme/mountain'
// window.rootDomain = '../../wp-content/themes/kit-child-theme/mountain'


new Vue({
  render: h => h(App),
}).$mount('#app')
